<div class="row justify-content-center">
  <header class="col-10 p-0 row justify-content-start">
    <p class="global-list-text">Showing only deployed items</p>
  </header>

  <ama-ng-app-store-inventory-panels class="df-sidenav-wrapper d-flex flex-row col-10 p-0"
    [selectedActor]="selectedEntity?.actor"
    [selectedActorParentOrg]="selectedEntity?.parentOrg"
    [officesInSelectedEntity]="officesInSelectedEntity"
    (officeSearchChange)="configurationService.updateOfficeSearch($event)"
    (orgOguSearchChange)="configurationService.updateOguSearch($event);">
    <ama-ng-app-store-configuration-hierarchy-list  [canCreateConfiguration]="canCreateConfiguration"
      [areConfigurationOverridesEnabled]="areConfigurationOverridesEnabled"/>
      <ama-ng-app-store-configuration-offices-list offices class="d-flex flex-column flex-grow-1"
        [canCreateConfiguration]="canCreateConfiguration"
        [areConfigurationOverridesEnabled]="areConfigurationOverridesEnabled"/>
      </ama-ng-app-store-inventory-panels>

      <footer class="col-10 px-0 d-flex justify-content-end">
        <div class="d-inline-flex my-2 mt-4 px-0">
          @if (canCreateConfiguration && areSomeOrAllEntitiesSelected) {
            <button
              class="btn btn-outline-primary mb-2 mb-md-0 me-2"
              id="cancel-btn"
              type="button"
              (click)="configurationService.cancelSelection()">
              Cancel
            </button>
          }

          <button class="btn btn-primary mb-2 mb-md-0"
            id="change-configuration-btn"
            name="action"
            type="submit"
            [disabled]="!canCreateConfiguration || !areSomeOrAllEntitiesSelected"
            (click)="configurationService.changeSelectedConfiguration()">
            Change configuration
          </button>
        </div>
      </footer>
    </div>

